import { createContext } from 'react';

export interface ProjectContextType {
    project_id: string | null;
    isLoading: boolean;
    // permissions: any;
    role: string;
    // setData: (data: any) => void;
    // getCompanyId: () => string;
}


export const ProjectContext = createContext<ProjectContextType | null>(null);